import {
  CategoriesDTO,
} from 'src/stores/backend/CategoriesStore/types';
import {
  LanguagesKey,
} from 'src/translations/types';
import {
  BaseFormViewModel,
} from '../types';

export class Category extends BaseFormViewModel<CategoriesDTO> {
  id?: number;

  englishName: string;

  arabicName: string;

  constructor(data: CategoriesDTO) {
    super();
    this.id = data.id;
    this.englishName = data.translations?.filter((item) => item.languageCode === LanguagesKey.EN)[0].title;
    this.arabicName = data.translations?.filter((item) => item.languageCode === LanguagesKey.AR)[0].title;
  }

  toDTO(): CategoriesDTO {
    return { } as CategoriesDTO;
  }
}
